/**
 * Machine epsilon used in calculations.
 *
 * @see https://en.wikipedia.org/wiki/Machine_epsilon
 */
export const EPSILON =
  Number.EPSILON === undefined ? Math.pow(2, -52) : Number.EPSILON;

/**
 * The largest number that can be represented in JavaScript.
 */
export const MAXIMUM_VALUE = Number.MAX_VALUE;

/**
 * Pi/2
 */
export const M_PI2 = Math.PI / 2;

/**
 * Pi * 2
 */
export const M_2PI = Math.PI * 2;
